import { useEffect } from 'react';

import { isUndo } from 'features/map/utils/mapCommon';

/**
 * Overrides default browser behavior:
 * pressing Ctrl+Z refocuses the most recently active input, even if it's not currently focused.
 * This hook prevents that behavior.
 */
export function useBlockGlobalUndoOutsideInputs() {
  useEffect(() => {
    const isTextField = (el: Element | null) =>
      !!el &&
      (el instanceof HTMLInputElement ||
        el instanceof HTMLTextAreaElement ||
        (el as HTMLElement).isContentEditable === true);

    const onKeyDown = (e: KeyboardEvent) => {
      if (!isUndo(e)) return;

      const active = document.activeElement;
      if (!isTextField(active)) {
        e.preventDefault();
      }
    };

    // Capture - to  beat the browser's default handlers
    window.addEventListener('keydown', onKeyDown, { capture: true });
    return () =>
      window.removeEventListener('keydown', onKeyDown, {
        capture: true,
      });
  }, []);
}
